<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/2note">Publisher’s Note</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/5chap1#chap1">At North Farm</a></p>
<p class="toc1"><a href="#/6chap2#chap2">Rain Moving In</a></p>
<p class="toc1"><a href="#/7chap3#chap3">The Songs We Know Best</a></p>
<p class="toc1"><span href="#/8chap4#chap4" title="Link target outside of Sample">When the Sun Went Down</span></p>
<p class="toc1"><span href="#/9chap5#chap5" title="Link target outside of Sample">Landscape (After Baudelaire)</span></p>
<p class="toc1"><span href="#/10chap6#chap6" title="Link target outside of Sample">Just Walking Around</span></p>
<p class="toc1"><span href="#/11chap7#chap7" title="Link target outside of Sample">A Fly</span></p>
<p class="toc1"><span href="#/12chap8#chap8" title="Link target outside of Sample">The Ongoing Story</span></p>
<p class="toc1"><span href="#/13chap9#chap9" title="Link target outside of Sample">Thank You For Not Cooperating</span></p>
<p class="toc1"><span href="#/14chap10#chap10" title="Link target outside of Sample">But What Is the Reader To Make of This?</span></p>
<p class="toc1"><span href="#/15chap11#chap11" title="Link target outside of Sample">Down by the Station, Early in the Morning</span></p>
<p class="toc1"><span href="#/16chap12#chap12" title="Link target outside of Sample">Around the Rough and Rugged Rocks the Ragged Rascal Rudely Ran</span></p>
<p class="toc1"><span href="#/17chap13#chap13" title="Link target outside of Sample">More Pleasant Adventures</span></p>
<p class="toc1"><span href="#/18chap14#chap14" title="Link target outside of Sample">Purists Will Object</span></p>
<p class="toc1"><span href="#/19chap15#chap15" title="Link target outside of Sample">Description of a Masque</span></p>
<p class="toc1"><span href="#/20chap16#chap16" title="Link target outside of Sample">The Path to the White Moon</span></p>
<p class="toc1"><span href="#/21chap17#chap17" title="Link target outside of Sample">Ditto, Kiddo</span></p>
<p class="toc1"><span href="#/22chap18#chap18" title="Link target outside of Sample">Introduction</span></p>
<p class="toc1"><span href="#/23chap19#chap19" title="Link target outside of Sample">I See, Said the Blind Man, as He Put Down His Hammer and Saw</span></p>
<p class="toc1"><span href="#/24chap20#chap20" title="Link target outside of Sample">Edition Peters, Leipzig</span></p>
<p class="toc1"><span href="#/25chap21#chap21" title="Link target outside of Sample">37 Haiku</span></p>
<p class="toc1"><span href="#/26chap22#chap22" title="Link target outside of Sample">Haibun</span></p>
<p class="toc1"><span href="#/27chap23#chap23" title="Link target outside of Sample">Haibun 2</span></p>
<p class="toc1"><span href="#/28chap24#chap24" title="Link target outside of Sample">Haibun 3</span></p>
<p class="toc1"><span href="#/29chap25#chap25" title="Link target outside of Sample">Haibun 4</span></p>
<p class="toc1"><span href="#/30chap26#chap26" title="Link target outside of Sample">Haibun 5</span></p>
<p class="toc1"><span href="#/31chap27#chap27" title="Link target outside of Sample">Haibun 6</span></p>
<p class="toc1"><span href="#/32chap28#chap28" title="Link target outside of Sample">Variation on a Noel</span></p>
<p class="toc1"><span href="#/33chap29#chap29" title="Link target outside of Sample">Staffage</span></p>
<p class="toc1"><span href="#/34chap30#chap30" title="Link target outside of Sample">The Lonedale Operator</span></p>
<p class="toc1"><span href="#/35chap31#chap31" title="Link target outside of Sample">Proust’s Questionnaire</span></p>
<p class="toc1"><span href="#/36chap32#chap32" title="Link target outside of Sample">Cups with Broken Handles</span></p>
<p class="toc1"><span href="#/37chap33#chap33" title="Link target outside of Sample">Just Someone You Say Hi To</span></p>
<p class="toc1"><span href="#/38chap34#chap34" title="Link target outside of Sample">They Like</span></p>
<p class="toc1"><span href="#/39chap35#chap35" title="Link target outside of Sample">So Many Lives</span></p>
<p class="toc1"><span href="#/40chap36#chap36" title="Link target outside of Sample">Never Seek to Tell Thy Love</span></p>
<p class="toc1"><span href="#/41chap37#chap37" title="Link target outside of Sample">Darlene’s Hospital</span></p>
<p class="toc1"><span href="#/42chap38#chap38" title="Link target outside of Sample">Destiny Waltz</span></p>
<p class="toc1"><span href="#/43chap39#chap39" title="Link target outside of Sample">Try Me! I’m Different!</span></p>
<p class="toc1"><span href="#/44chap40#chap40" title="Link target outside of Sample">One of the Most Extraordinary Things in Life</span></p>
<p class="toc1"><span href="#/45chap41#chap41" title="Link target outside of Sample">Whatever It Is, Wherever You Are</span></p>
<p class="toc1"><span href="#/46chap42#chap42" title="Link target outside of Sample">Trefoil</span></p>
<p class="toc1"><span href="#/47chap43#chap43" title="Link target outside of Sample">Problems</span></p>
<p class="toc1"><span href="#/48chap44#chap44" title="Link target outside of Sample">A Wave</span></p>
<p class="toc1" style="margin-top:20px;"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4TOC.vue?10d02e3c